import TypeToReducer from 'type-to-reducer';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

import {
  DELETE_COMPANY,
  GET_COMPANIES,
  MODIFY_COMPANY,
  SET_EDITING_COMPANY,
  TOGGLE_COMPANY,
  ADD_COMPANY,
  UPDATE_COMPANY,
  SET_CURRENT_COMPANY_ID,
} from 'companies/constants';

import { normalize, schema } from 'normalizr';

const company = new schema.Entity('companies');
const userCompanies = new schema.Entity('userCompanies', { company });

export const initialState = {
  currentCompanyId: null,
  currentCompany: null,
  editing: {
    name: '',
    shortname: '',
    active: true,
    modules: [],
  },
  isLoading: true,
  isModalOpened: false,
  entities: {},
  result: {},
};

export const getCompanies = (state, { payload }) => {
  const normalized = normalize({ companies: payload.companies }, { companies: [userCompanies] });
  return {
    ...state,
    isLoading: false,
    ...normalized,
  };
};

export const togglePending = (state, { meta }) => {
  return {
    ...state,
    entities: {
      ...state.entities,
      companies: {
        ...state.entities.companies,
        [meta.id]: { ...state.entities.companies[meta.id], isLoading: true },
      },
    },
  };
};

export const toggleFulfilled = (state, { meta, payload }) => {
  return {
    ...state,
    entities: {
      ...state.entities,
      companies: {
        ...state.entities.companies,
        [meta.id]: { ...payload.company, isLoading: false },
      },
    },
  };
};

export const toggleRejected = (state, { meta }) => {
  return {
    ...state,
    entities: {
      ...state.entities,
      companies: {
        ...state.entities.companies,
        [meta.id]: { ...state.entities.companies[meta.id], isLoading: false },
      },
    },
  };
};

export const deletePending = (state, { meta }) => {
  return {
    ...state,
    entities: {
      ...state.entities,
      companies: {
        ...state.entities.companies,
        [meta.id]: { ...state.entities.companies[meta.id], isLoading: true },
      },
    },
  };
};

export const deleteFulfilled = (state, { meta, payload }) => {
  return {
    ...state,
    entities: {
      ...state.entities,
      companies: {
        ...Object.keys(state.entities.companies)
          .filter((id) => id !== meta.id)
          .reduce((re, id) => ({ ...re, [id]: state.entities.companies[id] }), {}),
      },
    },
  };
};

export const deleteRejected = (state, { meta }) => {
  return {
    ...state,
    entities: {
      ...state.entities,
      companies: {
        ...state.entities.companies,
        [meta.id]: { ...state.entities.companies[meta.id], isLoading: false },
      },
    },
  };
};

export const setEditingCompany = (state, { payload: { id } }) => {
  return {
    ...state,
    editing: id
      ? { ...initialState.editing, ...state.entities.companies[id] }
      : { ...initialState.editing },
  };
};

export const modifyCompany = (state, { payload: { data } }) => ({
  ...state,
  editing: { ...state.editing, ...data },
});

export const addPending = (state, { meta }) => {
  return {
    ...state,
    editing: { ...state.editing, isLoading: true },
  };
};

export const addFulfilled = (state, { meta, payload }) => {
  return {
    ...state,
    editing: { ...state.editing, isLoading: false },
  };
};

export const addRejected = (state, { meta }) => {
  return {
    ...state,
    editing: { ...state.editing, isLoading: false },
  };
};

export const updatePending = (state, { meta }) => {
  return {
    ...state,
    editing: { ...state.editing, isLoading: true },
  };
};

export const updateFulfilled = (state, { meta, payload }) => {
  return {
    ...state,
    editing: { ...state.editing, isLoading: false },
  };
};

export const updateRejected = (state, { meta }) => {
  return {
    ...state,
    editing: { ...state.editing, isLoading: false },
  };
};

export const setCurrentCompanyId = (state, { payload }) => {
  return {
    ...state,
    currentCompanyId: payload.id,
    currentCompany: payload,
  };
};

const companiesReducers = {
  [GET_COMPANIES]: getCompanies,
  [MODIFY_COMPANY]: modifyCompany,
  [SET_EDITING_COMPANY]: setEditingCompany,
  [TOGGLE_COMPANY]: {
    [PENDING]: togglePending,
    [FULFILLED]: toggleFulfilled,
    [REJECTED]: toggleRejected,
  },
  [ADD_COMPANY]: {
    [PENDING]: addPending,
    [FULFILLED]: addFulfilled,
    [REJECTED]: addRejected,
  },
  [UPDATE_COMPANY]: {
    [PENDING]: updatePending,
    [FULFILLED]: updateFulfilled,
    [REJECTED]: updateRejected,
  },
  [DELETE_COMPANY]: {
    [PENDING]: deletePending,
    [FULFILLED]: deleteFulfilled,
    [REJECTED]: deleteRejected,
  },
  [SET_CURRENT_COMPANY_ID]: setCurrentCompanyId,
};

export default TypeToReducer(companiesReducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/reducers/companies_reducers.js